import { Fragment, useState } from "react";

import SectionCard from "./common/SectionCard";
import { getLang } from "../../../store/uiStore";
import "./IndicatorGeographySection.css";


export default function IndicatorGeographySection({
    data,
    quarter,
}) {
    const lang = getLang();
    const tr = {
        section: lang === "ru" ? "Анализ показателей по территории" : "Таҳлили нишондиҳандаҳо аз рӯи ҳудуд",
        indicator: lang === "ru" ? "Показатель" : "Нишондиҳанда",
        accepted: lang === "ru" ? "{tr.accepted}" : "Танҳо ҳисоботҳои қабулшуда ба назар гирифта мешаванд",
        territory: lang === "ru" ? "Территория" : "Ҳудуд",
        value: lang === "ru" ? "Значение" : "Арзиш",
        republic: lang === "ru" ? "Республика" : "Ҷумҳурӣ",
        reports: lang === "ru" ? "Отчетов" : "Ҳисоботҳо",
        acceptedShort: lang === "ru" ? "Принято" : "Қабулшуда",
    };

    const getName = (item) => lang === "ru"
        ? (item.name_ru ?? item.name_tj ?? "")
        : (item.name_tj ?? item.name_ru ?? "");

    const [selectedIndicator, setSelectedIndicator] =
        useState(1);

    const [expandedRegions, setExpandedRegions] =
        useState({});


    if (!data) {
        return null;
    }


    const indicators = data.indicators || [];

    const regions = data.regions || [];

    const republic = data.republic || [];


    const selectedPeriod = republic.find(
        item =>
            item.quarter === Number(quarter)
    );


    const republicValues =
        selectedPeriod?.values || {};


    const selectedIndicatorData =
        indicators.find(
            indicator =>
                indicator.id === Number(
                    selectedIndicator
                )
        );


    const toggleRegion = (regionId) => {

        setExpandedRegions(
            previous => ({
                ...previous,
                [regionId]:
                    !previous[regionId],
            })
        );

    };


    return (

        <SectionCard
            title={tr.section}
            icon="geo-alt"
        >

            {/* ---------------------------------------- */}
            {/* Выбор показателя */}
            {/* ---------------------------------------- */}

            <div className="row mb-4">

                <div className="col-lg-8">

                    <label className="form-label fw-semibold">

                        {tr.indicator}

                    </label>

                    <select
                        className="form-select"
                        value={selectedIndicator}
                        onChange={event =>
                            setSelectedIndicator(
                                Number(
                                    event.target.value
                                )
                            )
                        }
                    >

                        {indicators.map(
                            indicator => (

                                <option
                                    key={indicator.id}
                                    value={indicator.id}
                                >

                                    {indicator.code}
                                    {" — "}
                                    {lang === "ru"
                                        ? (indicator.name_ru ?? indicator.name_tj ?? "")
                                        : (indicator.name_tj ?? indicator.name_ru ?? "")}

                                </option>

                            )
                        )}

                    </select>

                </div>

            </div>


            {/* ---------------------------------------- */}
            {/* Название выбранного показателя */}
            {/* ---------------------------------------- */}

            {selectedIndicatorData && (

                <div className="mb-3">

                    <div className="fw-semibold">

                        {selectedIndicatorData.code}
                        {" — "}
                        {lang === "ru" ? (selectedIndicatorData.name_ru ?? selectedIndicatorData.name_tj ?? "") : (selectedIndicatorData.name_tj ?? selectedIndicatorData.name_ru ?? "")}

                    </div>

                    <div className="text-muted small">

                        {tr.accepted}

                    </div>

                </div>

            )}


            {/* ---------------------------------------- */}
            {/* Таблица */}
            {/* ---------------------------------------- */}

            <div className="table-responsive">

                <table className="table table-hover align-middle mb-0">

                    <thead className="table-light">

                        <tr>

                            <th>
                                Территория
                            </th>

                            <th
                                className="text-end"
                                style={{
                                    width: "180px",
                                }}
                            >
                                {tr.value}
                            </th>

                        </tr>

                    </thead>


                    <tbody>

                        {/* Республика */}

                        <tr className="table-primary">

                            <td className="fw-bold">

                                {tr.republic}

                            </td>

                            <td className="text-end fw-bold">

                                {
                                    republicValues[
                                        selectedIndicator
                                    ] ?? 0
                                }

                            </td>

                        </tr>


                        {/* Регионы */}

                        {regions.map(
                            region => {

                                const regionQuarter =
                                    region.quarters?.[
                                        Number(quarter)
                                    ];

                                const hasAcceptedReports =
                                    region.accepted_reports > 0;

                                const regionValue =
                                    regionQuarter?.[
                                        selectedIndicator
                                    ];

                                const expanded =
                                    !!expandedRegions[
                                        region.id
                                    ];


                                return (

                                    <Fragment key={region.id}>

                                        <tr
                                            key={
                                                region.id
                                            }
                                        >

                                            <td>

                                                <button
                                                    type="button"
                                                    className="btn btn-link p-0 text-decoration-none fw-semibold"
                                                    onClick={() =>
                                                        toggleRegion(region.id)
                                                    }
                                                >

                                                    {expanded
                                                        ? "▼"
                                                        : "▶"
                                                    }

                                                    {" "}

                                                    {getName(region)}

                                                </button>

                                                <div className="small text-muted mt-1">

                                                    {tr.reports}: {region.reports}

                                                    {" · "}

                                                    {tr.acceptedShort}: {region.accepted_reports}

                                                </div>

                                            </td>

                                            <td className="text-end fw-semibold">

                                                {
                                                    hasAcceptedReports
                                                        ? (regionValue ?? 0)
                                                        : "—"
                                                }

                                            </td>

                                        </tr>


                                        {expanded &&
                                            region.districts?.map(
                                                district => {

                                                    const districtQuarter =
                                                        district.quarters?.[
                                                            Number(quarter)
                                                        ];

                                                    const hasAcceptedReports =
                                                        district.accepted_reports > 0;

                                                    const districtValue =
                                                        districtQuarter?.[
                                                            selectedIndicator
                                                        ];

                                                    return (

                                                        <tr
                                                            key={
                                                                `district-${district.id}`
                                                            }
                                                        >


                                                            <td
                                                                className="ps-5"
                                                            >

                                                                <div>
                                                                    {getName(district)}
                                                                </div>

                                                                <div className="small text-muted">

                                                                    {tr.reports}: {district.reports}

                                                                    {" · "}

                                                                    Принято: {
                                                                        district.accepted_reports
                                                                    }

                                                                </div>

                                                            </td>

                                                            <td className="text-end">

                                                                {
                                                                    hasAcceptedReports
                                                                        ? (districtValue ?? 0)
                                                                        : "—"
                                                                }

                                                            </td>

                                                        </tr>

                                                    );

                                                }
                                            )
                                        }

                                    </Fragment>

                                );

                            }
                        )}

                    </tbody>

                </table>

            </div>

        </SectionCard>

    );
}
